import CopyToClipboardLarge from 'components/copyToClipboard/copyToClipboardLarge';

// Editing the overview and the « Factures » tab touches billing and contract
// data, so it stays behind the same two roles the inline form was gated on.
export const EDITOR_ROLES = [500, 515];

// `divide-*` cannot draw a two-column grid: `divide-y` puts a top border on
// every child but the first, so the second cell of the first row doubled the
// border the card already draws. The borders are placed per cell instead —
// left from the second column on, top from the second row on.
export const TWO_COLUMN_GRID =
  'grid grid-cols-2 [&>*]:border-gray-100 [&>*:nth-child(even)]:border-l [&>*:nth-child(n+3)]:border-t';

export const Field = ({ label, value }) => (
  <div className={'p-4 min-w-0'}>
    <CopyToClipboardLarge libelle={label} text={value} />
  </div>
);

/** A cell without the copy button, for a setting rather than a reference. */
export const PlainField = ({ label, value }) => (
  <div className={'p-4 min-w-0 flex flex-col'}>
    <div>{label}</div>
    <div className={'truncate text-gray-500 text-sm'}>{value}</div>
  </div>
);
